import React, {useRef, useEffect} from "react";
import "../Animations.css";
import AnimationSection from "./AnimationSection";
import ScrollableModel from "./3DLoader/3dModelLoaderScroll";

interface ParallaxEffectProps {
    imageSrc?: string;
    isVideo: boolean;
    isAnimation: boolean;
    children: React.ReactNode;
    className?: string;
}

const RevelarSeccion: React.FC<ParallaxEffectProps> = ({
                                                           imageSrc,
                                                           children,
                                                           isVideo = false,
                                                           isAnimation = false,
                                                           className = "",
                                                       }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const imageRef = useRef<HTMLImageElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            const wrapper = wrapperRef.current;
            const media = isVideo ? videoRef.current : imageRef.current;
            if (!wrapper || !media) return;

            const rect = wrapper.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const start = rect.top;
            const end = rect.bottom;
            const range = end - start;

            if (end > 0 && start < windowHeight) {
                const scrollProgress = (windowHeight - start) / (windowHeight + range);
                const clamped = Math.max(-1, Math.min(1, scrollProgress));
                const translateY = -1 - clamped * 35;
                media.style.transform = `translateY(${translateY}%)`;
            }
        };

        const onScroll = () => requestAnimationFrame(handleScroll);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [isVideo]);

    return (
        <div className="revelar-image-wrapper sticky-section" ref={wrapperRef}>
            <div className="revelar-image">
                {(!isAnimation) ? !isVideo ? (
                    <img src={imageSrc} ref={imageRef} alt="Fondo"/>
                ) : (
                    <video
                        src={imageSrc}
                        ref={videoRef}
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        className="parallax-video"
                    />
                ) :
                    <ScrollableModel />
                }
            </div>
            <div className="contenido-encima">{children}</div>
            <AnimationSection className={`revelar-image-bg ${className}`} animation="animate__fadeInTop" treshold={0.4}>
                <div>&nbsp;</div>
            </AnimationSection>
        </div>
    );
};

export default RevelarSeccion;
